module.exports = __webpack_public_path__ + "img/ToDustSigillSand.aa5d1bfa.png";